module.exports = __webpack_public_path__ + "static/media/unibestWeb1.189f1912.png";